import type {
  DeviceDto,
  ListAvailableProductsResponseBodyDto,
  MatchDto,
  MedicationDto,
  ProductDto,
} from '@montugroup/circuit-api-contracts';
import {
  ProductStrain as CircuitProductStrain,
  ProductFormulation,
  ProductIssueStatus,
} from '@montugroup/circuit-api-contracts';
import type { Price } from '@montugroup/circuit-shared/types/product';

export type eScriptPrescribedProduct = MedicationDto;

export interface SelectedProductData {
  prescriptionId?: number;
  product_name: string;
  price: Price;
  brand: string;
  is_concession: boolean;
}

export interface SelectedProduct {
  id: number;
  data: SelectedProductData & {
    product_id: number;
    quantity: number;
  };
}

export type ConfirmationPromise<T> = (data: T) => Promise<boolean>;

export type PlaceOrderFn = () => Promise<void>;

export type ValidateOrderFn = (placeOrderCallback: PlaceOrderFn) => Promise<void>;

export const ProductStrains = CircuitProductStrain;

export type ProductStrain = (typeof CircuitProductStrain)[keyof typeof CircuitProductStrain];

export const ProductFormulations = ProductFormulation;

export type ProductFormulation = (typeof ProductFormulations)[keyof typeof ProductFormulations];

export const IssueStatuses = ProductIssueStatus;

export type IssueStatus = (typeof IssueStatuses)[keyof typeof IssueStatuses];

type ListProductsResponseBody = ListAvailableProductsResponseBodyDto;

export type ListProductsResponse = ListProductsResponseBody;

export interface CartableProduct {
  productIssueStatus: IssueStatus;
}

export type Match = MatchDto;

export type Product = ProductDto;

export type Medication = MedicationDto;

export type Device = DeviceDto;
